module.exports = __webpack_public_path__ + "static/media/Web9M.927c5a66.jpg";